enum TxpEntitiesState {
    None,

    // The TXP assistant has only done basic processing of the email.
    // Entities are yet to be stamped.
    InitialProcessing,

    // The TXP assistant has only processed the email and stamped entities.
    // Calendar events are yet to be created.
    EmailProcessingOnly,

    // The TXP assistant processed the email and created calendar events
    Processed,

    // The TXP assistant is currently adding calendar events
    AddToCalendar,

    // The TXP assistant is currently removing calendar events
    RemoveFromCalendar,

    //  An error occurred while processing the entities
    PermanentError,

    // The TXP properties were cleared by the recovery service
    ClearedByRecovery,

    // The TXP assistant has intentionally decided to ignore this message (e.g. Junk mail)
    IgnoredByDesign,

    // The TXP assistant successfully processed the email and
    // there is no TXP data to show (e.g. cancellation emails)
    ProcessedWithNoData,

    // The TXP assistant is currently processing the edited event
    SaveUserEdits,
}

export default TxpEntitiesState;
